import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import FeedbackSection from './FeedbackSection';
import NextStepsSection from './NextStepsSection';
import styles from './styles.module.styl';

const ArticleFooter = ({
  articleUrl,
  githubEditLink,
  platformTitle,
  sidebarArticlesNextSteps,
  metadataNextSteps,
  isQuickstart
}) => (
  <div className={`${styles.articleFooter} article-footer`}>
    {(metadataNextSteps || sidebarArticlesNextSteps) &&
      <Fragment>
        <NextStepsSection
          isQuickstart={isQuickstart}
          platformTitle={platformTitle}
          sidebarArticlesNextSteps={sidebarArticlesNextSteps}
          metadataNextSteps={metadataNextSteps}
        />
        <div className={styles.separator} />
      </Fragment>
    }
    <FeedbackSection
      articleUrl={articleUrl}
      githubEditLink={githubEditLink}
      isQuickstart={isQuickstart}
    />
  </div>
);

ArticleFooter.defaultProps = {
  isQuickstart: false
};

ArticleFooter.propTypes = {
  articleUrl: PropTypes.string.isRequired,
  githubEditLink: PropTypes.string.isRequired,
  platformTitle: PropTypes.string,
  metadataNextSteps: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.bool
  ]),
  sidebarArticlesNextSteps: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.bool
  ]),
  isQuickstart: PropTypes.bool
};

export default ArticleFooter;
